import React from "react";
import IntroForm from "../components/overview/IntroForm";
class DashOverview extends React.Component {
  render() {
    return <IntroForm />;
  }
}

export default DashOverview;
